import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function NotFound() {
    const navigate = useNavigate();

    const handleGoBack = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        navigate(-1);
    };

    return (
        <>
            <h1>404 Not Found</h1>
            <h6>The page you searched for isn't available</h6>
            <h6>
                Try going back to the <Link to="#" onClick={handleGoBack}>last page</Link>
            </h6>
            <h6>
                Or you can go to the <Link to="/">home page</Link>
            </h6>
        </>
    );
}
